import type { User } from 'types/user';

export interface SelecaoEtapa3 {
  _id: string;
  userId: string;
  categoria: string;
  iniciativaIds: string[];
  iniciativaTitulos: string[];
  limite: number;
  enviadoEm: number;
  supersededAt?: number;
}

export type SelecaoEtapa3Input = Omit<SelecaoEtapa3, '_id' | 'supersededAt'>;

export interface RascunhoEtapa3 {
  _id: string;
  userId: string;
  notasRascunho: Record<string, { ids: string[]; titulos: string[] }>;
  atualizadoEm: number;
  supersededAt?: number;
}

export type RascunhoEtapa3Input = Omit<RascunhoEtapa3, '_id' | 'supersededAt'>;

// `extra.etapa` pode vir como número (3) ou string ('3') dependendo do
// registro do player no Funifier — sempre coagir antes de comparar.
const isEtapa3 = (user: User | null): boolean =>
  Number(user?.extra?.etapa) === 3;

export const getLimiteVotosEtapa3 = (user: User | null): number =>
  isEtapa3(user) ? 3 : 1;

export const TUTORIAL_ETAPA3_ID_BANCA = '6a0355f30af3a52b440771c5';
export const TUTORIAL_ETAPA3_ID_COMUM = '6a04e63e0af3a52b4407e43e';

export const getTutorialEtapa3IdForUser = (user: User | null): string =>
  getLimiteVotosEtapa3(user) === 3
    ? TUTORIAL_ETAPA3_ID_BANCA
    : TUTORIAL_ETAPA3_ID_COMUM;

export type StatusVotoPreliminar = 'rascunho' | 'em_aprovacao';

export interface VotoPreliminarEtapa3 {
  _id: string;
  assessorId: string;
  assessorNome: string;
  vpMatricula: string;
  vpNome: string;
  notasRascunho: Record<string, { ids: string[]; titulos: string[] }>;
  status: StatusVotoPreliminar;
  atualizadoEm: number;
  enviadoEm?: number;
  supersededAt?: number;
}

export type VotoPreliminarEtapa3Input = Omit<
  VotoPreliminarEtapa3,
  '_id' | 'supersededAt'
>;

export const isAssessorEtapa3 = (user: User | null): boolean =>
  !!user?.extra?.viewOnly && isEtapa3(user);

export const isVpEtapa3 = (user: User | null): boolean =>
  isEtapa3(user) && !user?.extra?.viewOnly;

export const getVpDestino = (
  user: User | null
): { matricula: string; nome: string } | null => {
  const resp = user?.extra?.responsavel;
  if (!resp?.matricula) return null;
  return { matricula: resp.matricula, nome: resp.nome ?? '' };
};
